export default [
  'YYYY-MM-DD HH:mm:ss',
  'YYYY-MM-DDTHH:mm:ss',
  'DD/MM/YYYY HH:mm:ss',
  'YYYY-MM-DD',
  'YYYY-MM-DDTHH:mm:ssZ',
  'MM/DD HH:mm'
]